import { useContext } from 'react'
import { BugReportContext, type BugReportContextValue } from './bugReportContext'

/**
 * Soft no-op fallback when the hook is invoked outside `<BugReportProvider>`.
 * `BugReportProvider` is mounted in the app root (main.tsx) and the i18n
 * test helper (`renderWithI18n`) wraps it too, so production callers always
 * see the real handler. Component tests that render a snippet directly via
 * `render(...)` (without the i18n wrapper) would otherwise crash on a
 * harmless feature-detect call — return a soft no-op so the UI degrades
 * gracefully and existing test files don't all need updating.
 */
const NOOP_BUG_REPORT: BugReportContextValue = {
  openBugReport: async () => {},
}

export function useBugReport(): BugReportContextValue {
  return useContext(BugReportContext) ?? NOOP_BUG_REPORT
}


